var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H19C19.2652 0 19.5196 0.117063 19.7071 0.325437C19.8946 0.533811 20 0.816426 20 1.11111V18.8889C20 19.1836 19.8946 19.4662 19.7071 19.6746C19.5196 19.8829 19.2652 20 19 20H1C0.734784 20 0.48043 19.8829 0.292893 19.6746C0.105357 19.4662 0 19.1836 0 18.8889V1.11111C0 0.816426 0.105357 0.533811 0.292893 0.325437C0.48043 0.117063 0.734784 0 1 0ZM2 2.22222V17.7778H18V2.22222H2ZM5 11.1111H7V15.5556H5V11.1111ZM9 4.44444H11V15.5556H9V4.44444ZM13 7.77778H15V15.5556H13V7.77778Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.b108a6fb.svg";
export { ForwardRef as ReactComponent };